import { ComponentBase, gh, getProps, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { DocumentEditor } from '@syncfusion/ej2-documenteditor';
export const properties = ['isLazyUpdate', 'plugins', 'acceptTab', 'autoResizeOnVisibilityChange', 'currentUser', 'defaultPasteOption', 'documentEditorSettings', 'documentName', 'documentSettings', 'enableAutoFocus', 'enableBookmarkDialog', 'enableBordersAndShadingDialog', 'enableCollaborativeEditing', 'enableColumnsDialog', 'enableComment', 'enableContextMenu', 'enableCursorOnReadOnly', 'enableEditor', 'enableEditorHistory', 'enableFontDialog', 'enableFootnoteAndEndnoteDialog', 'enableFormField', 'enableHyperlinkDialog', 'enableImageResizer', 'enableLayout', 'enableListDialog', 'enableLocalPaste', 'enableLockAndEdit', 'enableOptionsPane', 'enablePageSetupDialog', 'enableParagraphDialog', 'enablePersistence', 'enablePrint', 'enableRtl', 'enableSearch', 'enableSelection', 'enableSfdtExport', 'enableSpellCheck', 'enableStyleDialog', 'enableTableDialog', 'enableTableOfContentsDialog', 'enableTableOptionsDialog', 'enableTablePropertiesDialog', 'enableTextExport', 'enableTrackChanges', 'enableWordExport', 'headers', 'height', 'isReadOnly', 'layoutType', 'locale', 'pageGap', 'pageOutline', 'serverActionSettings', 'serviceUrl', 'showComments', 'showRevisions', 'useCtrlClickToFollowHyperlink', 'userColor', 'width', 'zIndex', 'zoomFactor', 'actionComplete', 'afterFormFieldFill', 'beforeAcceptRejectChanges', 'beforeCommentAction', 'beforeFileOpen', 'beforeFormFieldFill', 'beforePaneSwitch', 'beforePaste', 'commentBegin', 'commentDelete', 'commentEnd', 'contentChange', 'contentControl', 'created', 'customContextMenuBeforeOpen', 'customContextMenuSelect', 'destroyed', 'documentChange', 'keyDown', 'requestNavigate', 'searchResultsChange', 'selectionChange', 'serviceFailure', 'trackChange', 'unsupportedBorderStyleClick', 'viewChange', 'zoomFactorChange', 'beforeXmlHttpRequestSend', 'documentLoadFailed'];
export const modelProps = [];
export const testProp = getProps({ props: properties });
export const props = testProp[0], watch = testProp[1], emitProbs = Object.keys(watch);
emitProbs.push('modelchanged', 'update:modelValue');
for (let props of modelProps) {
    emitProbs.push('update:' + props);
}
/**
 * Represents the Essential JS 2 VueJS Document Editor Component
 * ```html
 * <ejs-documenteditor id='container'></ejs-documenteditor>
 * ```
 */
export let DocumentEditorComponent = vueDefineComponent({
    name: 'DocumentEditorComponent',
    mixins: [ComponentBase],
    props: props,
    watch: watch,
    emits: emitProbs,
    provide() { return { custom: this.custom }; },
    data() {
        return {
            ej2Instance: new DocumentEditor({}),
            propKeys: properties,
            models: modelProps,
            hasChildDirective: false,
            hasInjectedModules: true,
            tagMapper: {},
            tagNameMapper: {},
            isVue3: !isExecute,
            templateCollection: {},
        };
    },
    created() {
        this.bindProperties();
        this.ej2Instances._setProperties = this.ej2Instances.setProperties;
        this.ej2Instances.setProperties = this.setProperties;
        this.ej2Instances.clearTemplate = this.clearTemplate;
        this.updated = this.updated;
    },
    render(createElement) {
        let h = !isExecute ? gh : createElement;
        let slots = null;
        if (!isNullOrUndefined(this.$slots.default)) {
            slots = !isExecute ? this.$slots.default() : this.$slots.default;
        }
        return h('div', slots);
    },
    methods: {
        clearTemplate(templateNames) {
            if (!templateNames) {
                templateNames = Object.keys(this.templateCollection || {});
            }
            if (templateNames.length && this.templateCollection) {
                for (let tempName of templateNames) {
                    let elementCollection = this.templateCollection[tempName];
                    if (elementCollection && elementCollection.length) {
                        for (let ele of elementCollection) {
                            this.destroyPortals(ele);
                        }
                        delete this.templateCollection[tempName];
                    }
                }
            }
        },
        setProperties(prop, muteOnChange) {
            if (this.isVue3) {
                this.models = !this.models ? this.ej2Instances.referModels : this.models;
            }
            if (this.ej2Instances && this.ej2Instances._setProperties) {
                this.ej2Instances._setProperties(prop, muteOnChange);
            }
            if (prop && this.models && this.models.length) {
                Object.keys(prop).map((key) => {
                    this.models.map((model) => {
                        if ((key === model) && !(/datasource/i.test(key))) {
                            if (this.isVue3) {
                                this.ej2Instances.vueInstance.$emit('update:' + key, prop[key]);
                            }
                            else {
                                this.$emit('update:' + key, prop[key]);
                                this.$emit('modelchanged', prop[key]);
                            }
                        }
                    });
                });
            }
        },
        custom() {
            this.updated();
        },
        destroy() {
            return this.ej2Instances.destroy();
        },
        enableAllModules() {
            return this.ej2Instances.enableAllModules();
        },
        exportAsImage(pageNumber, format) {
            return this.ej2Instances.exportAsImage(pageNumber, format);
        },
        exportContentControlData(isExportRichTextData) {
            return this.ej2Instances.exportContentControlData(isExportRichTextData);
        },
        exportFormData() {
            return this.ej2Instances.exportFormData();
        },
        fitPage(pageFitType) {
            return this.ej2Instances.fitPage(pageFitType);
        },
        focusIn() {
            return this.ej2Instances.focusIn();
        },
        getBookmarks() {
            return this.ej2Instances.getBookmarks();
        },
        getComments() {
            return this.ej2Instances.getComments();
        },
        getDefaultCharacterFormat() {
            return this.ej2Instances.getDefaultCharacterFormat();
        },
        getDefaultParagraphFormat() {
            return this.ej2Instances.getDefaultParagraphFormat();
        },
        getDefaultSectionFormat() {
            return this.ej2Instances.getDefaultSectionFormat();
        },
        getDocumentCharacterFormat() {
            return this.ej2Instances.getDocumentCharacterFormat();
        },
        getDocumentParagraphFormat() {
            return this.ej2Instances.getDocumentParagraphFormat();
        },
        getFormFieldInfo(name) {
            return this.ej2Instances.getFormFieldInfo(name);
        },
        getFormFieldNames() {
            return this.ej2Instances.getFormFieldNames();
        },
        getStyleNames(styleType) {
            return this.ej2Instances.getStyleNames(styleType);
        },
        getStyles(styleType) {
            return this.ej2Instances.getStyles(styleType);
        },
        importContentControlData(contentControlInfo) {
            return this.ej2Instances.importContentControlData(contentControlInfo);
        },
        importFormData(formData) {
            return this.ej2Instances.importFormData(formData);
        },
        open(inputData) {
            return this.ej2Instances.open(inputData);
        },
        openAsync(inputData) {
            return this.ej2Instances.openAsync(inputData);
        },
        openBlank() {
            return this.ej2Instances.openBlank();
        },
        print(printWindow) {
            return this.ej2Instances.print(printWindow);
        },
        resetContentControlData(contentControInfo) {
            return this.ej2Instances.resetContentControlData(contentControInfo);
        },
        resetFormFields(name) {
            return this.ej2Instances.resetFormFields(name);
        },
        resize(width, height) {
            return this.ej2Instances.resize(width, height);
        },
        save(fileName, formatType) {
            return this.ej2Instances.save(fileName, formatType);
        },
        saveAsBlob(formatType) {
            return this.ej2Instances.saveAsBlob(formatType);
        },
        scrollToPage(pageNumber) {
            return this.ej2Instances.scrollToPage(pageNumber);
        },
        serialize() {
            return this.ej2Instances.serialize();
        },
        setCustomFonts(fonts) {
            return this.ej2Instances.setCustomFonts(fonts);
        },
        setDefaultCharacterFormat(characterFormat) {
            return this.ej2Instances.setDefaultCharacterFormat(characterFormat);
        },
        setDefaultParagraphFormat(paragraphFormat) {
            return this.ej2Instances.setDefaultParagraphFormat(paragraphFormat);
        },
        setDefaultSectionFormat(sectionFormat) {
            return this.ej2Instances.setDefaultSectionFormat(sectionFormat);
        },
        setDocumentCharacterFormat(characterFormat) {
            return this.ej2Instances.setDocumentCharacterFormat(characterFormat);
        },
        setDocumentParagraphFormat(paragraphFormat) {
            return this.ej2Instances.setDocumentParagraphFormat(paragraphFormat);
        },
        setFormFieldInfo(name, formFieldInfo) {
            return this.ej2Instances.setFormFieldInfo(name, formFieldInfo);
        },
        showDialog(dialogType) {
            return this.ej2Instances.showDialog(dialogType);
        },
        showOptionsPane() {
            return this.ej2Instances.showOptionsPane();
        },
        showRestrictEditingPane(show) {
            return this.ej2Instances.showRestrictEditingPane(show);
        },
        showXmlPane() {
            return this.ej2Instances.showXmlPane();
        },
        updateFields() {
            return this.ej2Instances.updateFields();
        },
        verbalizeFromCursorLocation() {
            return this.ej2Instances.verbalizeFromCursorLocation();
        },
    }
});
export const DocumentEditorPlugin = {
    name: 'ejs-documenteditor',
    install(Vue) {
        Vue.component(DocumentEditorPlugin.name, DocumentEditorComponent);
    }
};
